import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import setStyle from '@/utils/setStyle'
import clsx from 'clsx'

import connect from '@/images/connect.svg'
import discover from '@/images/discover.svg'
import guide from '@/images/guide.svg'
import support from '@/images/support.svg'

const getIcon = icon => {
	switch (icon) {
		case 'connect': return connect
		case 'discover': return discover
		case 'guide': return guide
		case 'support': return support
		default: return false
	}
}

const CardItem = ({ heading, _rawRichtext, image, cta, icon }) => (
	<article className="rounded-xl overflow-hidden text-grounding-navy">
		<figure>
			<Img image={image} />
		</figure>

		<div className="p-4 rounded-b-2xl richtext">
			<HTag className="h3" {...heading} />
			<Richtext raw={_rawRichtext} />
			<p className="flex items-center gap-4 font-bold md:text-xl">
				<span className="grow shrink-0"><CTA {...cta} arrow /></span>
				<img className="" src={getIcon(icon)} alt="" />
			</p>
		</div>
	</article>
)

const CardSection = ({ heading, cta, style, pattern, items }) => {
	const hasLine = heading.text === 'Upcoming Programs'

	return (
		<section className={clsx(setStyle(style), pattern)}>
			<div className="section">
				<header className="text-center richtext">
					<HTag className="h1" {...heading} />
					<p className={clsx(hasLine && 'directional-line')}>
						<CTA {...cta} />
					</p>
				</header>
				<ul className="relative carousel gap-6 mt-12">
					{items?.map((item, key) => (
						<li className="colored-list rounded-xl overflow-hidden" key={key}>
							<CardItem {...item} />
						</li>
					))}
				</ul>
			</div>
		</section>
	)
}

export default CardSection
